export function useScrollTo() {
  const scrollToId = (id: string, offset: number = 0) => {
    if(document) {
      const element = document.getElementById(id)
      if (element) {
        // Calculate the position to scroll to, considering the offset
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition + offset
    
        // Scroll to the calculated position with smooth behavior
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  const checkHashAndScroll = () => {
    const route = useRoute()
    onMounted(() => {
      const hash = route.hash
      if (hash) {
        const id = hash.replace('#', '')
        scrollToId(id)
      }
    })
  }

  return { scrollToId, checkHashAndScroll }
}
